import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginEmailVerificationMutationRequest,
  PostApiLoginEmailVerificationMutationResponse,
} from "../../../types/PostApiLoginEmailVerification";

export function getPostApiLoginEmailVerificationUrl() {
  return `/api/Login/email-verification` as const;
}

/**
 * {@link /api/Login/email-verification}
 */
export async function postApiLoginEmailVerification(
  data?: PostApiLoginEmailVerificationMutationRequest,
  config: Partial<
    RequestConfig<PostApiLoginEmailVerificationMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginEmailVerificationMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginEmailVerificationMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginEmailVerificationUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
